import useDeviceType from "../../Utils/useDeviceType";
import { RouteComponentProps, useLocation } from "react-router-dom";
import React, { useMemo } from "react";
import ScoreProvider from "./Components/CourseScoreProvider";
import DetailLayout from "pages/CourseDetail/components/DetailLayout";
import PageCourseScore from "./PageCourseScore";
import qs from "qs";
import PageCourseScoreMobile from "./PageCourseScoreMobile";
interface IProps {
    courseNo: string;
    courseSeq: string;
    weekTimeId: string;
    tab: string;
}

const Index = ({ match }: RouteComponentProps<IProps>) => {
    const { isPC } = useDeviceType();
    const location = useLocation();
    const { courseName } = useMemo(
        () => qs.parse(location.search, { ignoreQueryPrefix: true }) as any,
        [location.search]
    );
    return (
        <ScoreProvider type={{ ...match.params }}>
            <DetailLayout
                breadcrumb="成绩"
                title={match.params.tab === "detail" ? "成绩" : "成绩规则"}>
                {isPC && <PageCourseScore courseName={courseName} />}

                {!isPC && <PageCourseScoreMobile tab={match.params.tab} />}
            </DetailLayout>
        </ScoreProvider>
    );
};

export default Index;
